import React, { FC } from 'react';

export const Plus: FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="25" height="24" viewBox="0 0 25 24" {...props}>
    <path
      fill="currentColor"
      d="M12.566 4.083a1.33 1.33 0 0 0-1.31 1.349v5.32h-5.32a1.33 1.33 0 1 0 0 2.66h5.32v5.321a1.329 1.329 0 0 0 2.564.515 1.33 1.33 0 0 0 .096-.515v-5.32h5.32a1.331 1.331 0 1 0 0-2.66h-5.32V5.431a1.33 1.33 0 0 0-1.35-1.349Z"
    />
  </svg>
);
